// extracted by mini-css-extract-plugin
module.exports = {"CategoryLayout":"CategoryPage_CategoryLayout__1wwsA"};